import { Component } from '@angular/core';
import { AppState } from '../../../app.state';
import { Store } from '@ngrx/store';
import { getFlashState, State as FlashState } from '../store/flash.reducer';
import { Observable } from 'rxjs/Observable';
import { DismissFlash } from '../store/flash.actions';

@Component({
  selector: 'flash-info',
  template: require('./flash-info.component.html'),
})
export class FlashInfoComponent {
  public flashState$: Observable<FlashState>;

  constructor(
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.flashState$ = this.store.select(getFlashState);
  }

  dismiss() {
    this.store.dispatch(new DismissFlash());
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/flash/flash-info/flash-info.component.ts